import { call, put, takeLatest } from "redux-saga/effects";
import request from '../../../components/Utils/httpHelper';
import * as types from "./actionTypes";
import * as actions from "./actions";
import { CORE_API } from "../../../config";
import { Preloading } from "../../../components/UI/Preloader/action";

function fetchCorporatesAPI() {
  return request(`${CORE_API}/corporate/list/byIdName`, {
    method: "GET"
  });
}

function* getCorporatesSaga() {
  try {
    yield put(Preloading(true));
    const response = yield call(fetchCorporatesAPI);

    const corporates = response.data.map((c) => ({
      id: c.id,
      name: c.corporateName,
    }));

    yield put(actions.getCorporatesSuccess(corporates));
  } catch (error) {
    yield put(
      actions.getCorporatesFailure(
        error.response?.data?.message || error.message
      )
    );
  } finally {
    yield put(Preloading(false));
  }
}

function downloadTemplateAPI(corporateId, rowCount) {
  return request(
    `${CORE_API}/onboarding/${corporateId}/bulk-user-template?rowCount=${rowCount}`,
    {
      method: "GET",
      responseType: "blob",
    }
  );
}

function* downloadTemplateSaga(action) {
  try {
    yield put(Preloading(true));


    const { corporateId, rowCount } = action.payload;
    const response = yield call(downloadTemplateAPI, corporateId, rowCount);

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Bulk_User_Template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    yield put(actions.downloadTemplateSuccess());
  } catch (error) {
    yield put(
      actions.downloadTemplateFailure(
        error.response?.data?.message || error.message
      )
    );
  } finally {
    yield put(Preloading(false));
  }
}


function bulkUploadAPI(corporateId, file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);

  return request(
    `${CORE_API}/onboarding/${corporateId}/bulk-user-upload`,
    {
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
      onUploadProgress,
    }
  );
}


function* bulkUploadSaga(action) {
  try {
    yield put(Preloading(true));

    const { corporateId, file, progress } = action.payload;

    const response = yield call(
      bulkUploadAPI,
      corporateId,
      file,
      progress
    );

    if (response.status === 200) {
      yield put(
        actions.bulkUploadSuccess("Users created successfully.")
      );
    }
  } catch (error) {
    const response = error.response;

    if (response?.data instanceof Blob) {
      const blob = response.data;
      const contentType = response.headers?.["content-type"];

      if (
        contentType &&
        contentType.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Bulk_User_Error_Report.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        yield put(
          actions.bulkUploadFailure({
            message:
              "Validation failed. Error report downloaded automatically.",
          })
        );
      } else {
        try {
          const text = yield blob.text();
          const data = JSON.parse(text);

          yield put(
            actions.bulkUploadFailure({
              message:
                data?.message || "Bulk upload failed.",
            })
          );
        } catch (parseError) {
          yield put(
            actions.bulkUploadFailure({
              message: "Bulk upload failed.",
            })
          );
        }
      }
    } else {
      yield put(
        actions.bulkUploadFailure({
          message:
            response?.data?.message ||
            error.message ||
            "Bulk upload failed.",
        })
      );
    }
  } finally {
    yield put(Preloading(false));
  }
}

export function* corporateBulkEndUserSagaFetch() {
  yield takeLatest(types.GET_CORPORATES_REQUEST, getCorporatesSaga);
  yield takeLatest(types.DOWNLOAD_TEMPLATE_REQUEST, downloadTemplateSaga);
  yield takeLatest(types.BULK_UPLOAD_REQUEST, bulkUploadSaga);
}